import { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { LOGIN_MUTATION, ME_QUERY } from "graphql/APICalls";

import { MapContext } from "providers/MapProvider";
import { PasswordInput } from "components/Helpers";
import 'styles/Login.css';

function LogIn() {

  const { updateLocation } = useContext(MapContext);

  const [emailOrUsername, setEmailOrUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [sendLoginMutation, loginMutation] = useMutation(LOGIN_MUTATION);
  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    sendLoginMutation({
      variables: { emailOrUsername, password },
      fetchPolicy: 'network-only',
      onCompleted: () => { updateLocation(); navigate('/') },
      onError: error => { setErrorMessage(error.message) },
      refetchQueries: [ { query: ME_QUERY } ]
    });
  };

  return (
    <div className="auto-scrollbar">
      <div className="centerer login-signup-overlay">
        <form className="centered form-1" onSubmit={handleLogin}>
          <label>Email or username</label>
          <input type="text" autoCapitalize="off" value={emailOrUsername} onChange={(e) => setEmailOrUsername(e.target.value.trim())} />
          <label>Password</label>
          <PasswordInput showPassword={showPassword} setShowPassword={setShowPassword} password={password} setPassword={setPassword}/>
          <div className="wide error-message" style={{display: errorMessage.length ? 'block' : 'none'}}>{errorMessage}</div>
          <button type="submit" disabled={loginMutation.loading}>Log in</button>
          <div className="tall wide">
            <Link className="forgot-password-link" to="/forgot-password">Forgot Password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LogIn